var formError = {
    commentFail: 'There was an issue submitting your comments. Please try again later or use our Online Chat for help.',
    partialError: '',
    pleaseSelect: 'Please select an option to continue.',
    pleaseAnswer: 'An answer is required to continue.',
    pleaseSelectDate: 'Please select a date to continue.',
    invalidAmount: 'Amount cannot be greater than the purchase price.',
    amountMustBe: 'Amount must be greater than 0',
    charactersOverLimit: '{{charsOverLimit}} characters over limit',
    oneCharacterOverLimit: '1 character over limit',
    tooManyCharacters: "We're sorry, you have reached the maximum amount of 1,000 characters.",
    moreThanHundredCharacters: "We're sorry, you have reached the maximum amount of 100 characters.",
    required: 'This field is required and cannot be left empty.',
    unsupportedFileType: 'Unsupported file type. Please try again with one of the supported file types: PNG, JPG, or PDF.',
    maximumFileSize: 'Attachment exceeds the maximum size of {{maxFileSize}}. Please reduce the total file size and try again.',
    cancelReason: 'Please enter the reason for canceling.',
    cancelReasonPlaceholder: 'Enter reason for canceling',
    pleaseSelectAdditionalTransactions: 'Please select additional transactions from this merchant to dispute'
};
export default formError;
//# sourceMappingURL=formError.js.map